import React from 'react'

class LinkedInCard extends React.Component {
  render() {
    return (
      <div>
        <div className='card card-single'>
          <div className='card-body'>
            <div className='qn'>
              Save time and import your experience
            </div>
            <div className='btn btn-lg btn-linkedin mb-4'>
              <div className='fa fa-linkedin-square fa-lg' />
              &nbsp;
              <span>Continue with LinkedIn</span>
            </div>

            <div className='smaller'>
              <p>What we will be importing</p>
              <ul className='pl-3'>
                <li>Occupation title</li>
                <li>Name of your employer</li>
                <li>Type of employment</li>
                <li>How long you worked there</li>
              </ul>
            </div>
          </div>
        </div>
        <div className='link_underline' onClick={this.props.onSkipClick}>
          No thanks, I'll enter the details manually
        </div>
      </div>
    )
  }
}

export default LinkedInCard;
